import type { UiActionParameters } from '../../ui/parameters/ui-action'

import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 0

/**
 * Static `ui_action` parameters shared by every search result click (ET-1): a
 * result is always a card poster and the interaction is always a tap
 * (ET-1.11, ET-1.13).
 *
 * Unlike the other `ui_action` parameter maps, `route` is not taken from the
 * route-history breadcrumb here — ET-1.6 requires the search section, which the
 * clicked card knows and passes at construction time.
 */
export const parameters = new SnapshotMap<UiActionParameters>(
  SNAPSHOTS_TO_KEEP,
  [
    ['uiElementType', 'poster'],
    ['actionName', 'tap'],
  ]
)
